<template>
	<div>
		<GroupsReminders></GroupsReminders>
	</div>
</template>

<script>

import GroupsReminders from '@/components/reminders/GroupsReminders';

export default {
	name: 'Groups',
	components: {
		GroupsReminders
	}
}

</script>